export default __webpack_public_path__ + "static/media/rss.7770bf4e.svg";